import { FC, memo, useId } from "react";
import { MatchStatus } from "service";
import styled from "styled-components";
import { SIDE } from "_constants";
import { getTeamColors } from "components/colors";

//TODO: refine the gradient and shape to better match the ice hockey rink and icing effect
export const IcingIndicator: FC<{ status: MatchStatus }> = memo(
  ({ status: { x, y, sc, nsc, side, ...status } }) => {
    const gradId = useId();
    const fillUrl = `url(#${gradId})`;
    const hasCoords = typeof x === "number" && typeof y === "number";
    const fx: number = hasCoords
      ? (x as number)
      : side === SIDE.HOME
      ? 0.25
      : 0.75;
    const { home, away } = getTeamColors(status as any);
    const fillColor = side === SIDE.HOME ? home : away;

    return (
      <>
        <PathContainer className="icing-indicator" side={side}>
          <svg
            width="70%"
            height="100%"
            viewBox="0 0 297 180"
            preserveAspectRatio="none"
          >
            <defs>
              <linearGradient
                id={gradId}
                x1="297"
                y1="90"
                x2="0"
                y2="90"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor={fillColor} stopOpacity={0.75} />
                <stop
                  offset="0.246974"
                  stopColor={fillColor}
                  stopOpacity={0.5}
                />
                <stop offset="1" stopColor={fillColor} stopOpacity={0.4} />
              </linearGradient>
            </defs>

            {nsc === "1288" && (
              <RotGroup data-side={side}>
                <IcingPath
                  data-side={side}
                  x={fx}
                  style={{ opacity: "0.7" }}
                  fill={fillUrl}
                  d="M0 20C0 8.9543 8.95431 0 20 0L170 0V180H20C8.9543 180 0 171.046 0 160V20Z"
                />
              </RotGroup>
            )}
          </svg>
        </PathContainer>
      </>
    );
  }
);

const PathContainer = styled.div<{ side?: SIDE }>`
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: ${(p) => (p.side === SIDE.HOME ? "flex-start" : "flex-end")};
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10;
  padding-bottom: ${(p) => (p.side === SIDE.AWAY ? "1vw" : "0")};
  padding-top: ${(p) => (p.side === SIDE.HOME ? "2vw" : "0")};
  overflow: hidden;
  padding-left: ${(p) => (p.side === SIDE.HOME ? "5vw" : "0")};
  padding-right: ${(p) => (p.side === SIDE.AWAY ? "5vw" : "0")};

  & > svg {
    width: 50%;
    height: calc(96% + 1vw);
    display: block;
    transform: translateY(${(p) => (p.side === SIDE.HOME ? "-1vw" : "0")});
    z-index: 10;
  }
`;

const RotGroup = styled.g`
  transition: none; /* prevent rotation animation on side change */
  transform-origin: 148.5px 90px; /* center of 297x180 */
  transform-box: fill-box;

  &[data-side="2"] {
    transform: rotate(180deg);
  }
`;

const IcingPath = styled.path<{ x: number }>``;
